var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0a.5.5 0 0 1 .492.41L12 .5v12a.5.5 0 0 1-.992.09L11 12.5V.5a.5.5 0 0 1 .5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.146 8.146a.5.5 0 0 1 .638-.057l.07.057 3.646 3.647 3.646-3.647a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07-4 4a.5.5 0 0 1-.638.057l-.07-.057-4-4a.5.5 0 0 1 0-.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11a.5.5 0 0 1 .09.992L6.5 12l-.765-.001-4.167 5h20.863l-4.167-5L17 12a.5.5 0 0 1-.492-.41l-.008-.09a.5.5 0 0 1 .41-.492L17 11h1.5a.5.5 0 0 1 .322.117l.062.063 5 6a.5.5 0 0 1-.302.814L23.5 18H.5a.5.5 0 0 1-.432-.753l.048-.067 5-6a.5.5 0 0 1 .296-.172L5.5 11h1ZM20 20a.5.5 0 0 1 .09.992L20 21h-4a.5.5 0 0 1-.09-.992L16 20h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17a.5.5 0 0 1 .492.41l.008.09v4a2.507 2.507 0 0 1-2.336 2.495L21.5 24h-19a2.507 2.507 0 0 1-2.495-2.336L0 21.5v-4a.5.5 0 0 1 .992-.09L1 17.5v4c0 .775.599 1.42 1.356 1.493L2.5 23h19c.775 0 1.42-.599 1.493-1.356L23 21.5v-4a.5.5 0 0 1 .5-.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.15bfa85240bfe8fd4f66e10c5617e538.svg";